import React from 'react'
import ReactDOM from 'react-dom'
import SiteMap from '../Components/SiteMap'

const siteMap = document.getElementsByClassName('site_map')
for (var i = 0; i < siteMap.length; i++) {
	const dataSiteMap = JSON.parse(siteMap[i].getAttribute('data-site_map'))
	const _arrObj = [];
	let _arr = []
	let c = 0;
	for (var _i = 0; _i < dataSiteMap.map.length; _i++) {
		_arr[c] = dataSiteMap.map[_i]
		c++;
		if(c === 4 || _i === 0){
			c = 0;
			_arrObj.push(_arr);
			_arr = [];
		}
	}
	ReactDOM.render(<SiteMap map={_arrObj} />,siteMap[i])
}


// WEBPACK FOOTER //
// ./src/build/site_map.js